module.exports = __webpack_public_path__ + "static/img/icon_wycx.12041e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_wycx.png
// module id = r6lz
// module chunks = 11